export default function PaginationBar({
  page = 1,
  totalPages = 0,
  total = null,
  loading = false,
  onPageChange,
}) {
  if (!totalPages || totalPages < 1) return null;

  const current = Math.max(1, Number(page) || 1);
  const last = Math.max(1, Number(totalPages) || 1);

  return (
    <nav className="pagination-bar" role="navigation" aria-label="Pagination">
      <button
        type="button"
        className="pagination-bar__btn"
        disabled={current <= 1 || loading}
        onClick={() => onPageChange?.(current - 1)}
      >
        ← Previous
      </button>
      <span className="pagination-bar__status">
        Page {current} of {last}
        {typeof total === "number" ? ` · ${total.toLocaleString()} total` : ""}
      </span>
      <button
        type="button"
        className="pagination-bar__btn"
        disabled={current >= last || loading}
        onClick={() => onPageChange?.(current + 1)}
      >
        Next →
      </button>
    </nav>
  );
}
